<template>
  <NavBar class="ViewerNavBar">
    <div
      v-if="showPlanModeToggle"
      class="d-flex flex-column mr-3 align-items-center"
    >
      <span style="color: white">{{ $t('components.navbar.planmode') }}</span>
      <ToggleSwitch v-model="planmode" />
    </div>

    <CountrySelection
      v-if="superuser || visibleCountrySelection"
      filter="prognose"
      class="mr-3"
    />
    <!-- This may be not 100% accurate, due to feature restrictions.
         To avoid complexity the dropdown is then simply shown with 1 item. -->
    <MunicipalitySelection
      v-if="canAccessMultipleMunicipalities"
      filter="prognose"
      class="mr-3"
    />

    <ScenarioInputs />

    <router-link
      v-if="superuser"
      class="d-inline-flex align-center mr-3"
      :to="{ name: 'Dashboard', params: { municipality: activeMunicipalitySlug } }"
    >
      <i class="far fa-fw fa-gear icon" />
    </router-link>
  </NavBar>
</template>

<script>
import NavBar from '@/components/common/NavBar'
import ScenarioInputs from '@/components/navbar/ScenarioInputs'
import CountrySelection from '@/components/navbar/CountrySelection'
import MunicipalitySelection from '@/components/navbar/MunicipalitySelection'
import ToggleSwitch from '@/components/form/ToggleSwitch'

import { codeToSlug, isProxyByCode } from '@/services/municipalities'

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ViewerNavBar',
  components: {
    NavBar, ScenarioInputs, CountrySelection, MunicipalitySelection, ToggleSwitch,
  },
  computed: {
    ...mapGetters('config', [
      'isPlanmodeEnabled',
      'getActiveMunicipality',
    ]),
    ...mapGetters('access', [
      'getActiveMunicipality',
      'municipalityCodeList',
      'canAccessPlanmode',
      'canPreAccessPlanMode',
      'canAccessMultipleMunicipalities',
      'canAccessCountry',
    ]),
    ...mapGetters('planmode', {
      isPlanmodeActive: 'isActive',
    }),
    superuser() {
      return this.$auth.user?.['https://evmaps.nl/superuser']
    },
    visibleCountrySelection() {
      const countries = this.canAccessCountry(this.municipalityCodeList)
      return Array.isArray(countries) && countries.length > 1
    },
    activeMunicipalitySlug() {
      return codeToSlug({ code: this.getActiveMunicipality })
    },
    showPlanModeToggle() {
      return ! isProxyByCode({ code: this.getActiveMunicipality }) &&
          (this.superuser || (this.isPlanmodeEnabled && this.canAccessPlanmode) || this.canPreAccessPlanMode)
    },
    planmode: {
      get() {
        return this.isPlanmodeActive
      },
      set(active) {
        this.setPlanmodeState({ active })
      },
    },
  },
  methods: {
    ...mapMutations('planmode', {
      setPlanmodeState: 'setActiveState',
    }),
  },
}
</script>
<style lang="scss" scoped>
.ViewerNavBar {
  .icon {
    color: white;
    font-size: 1.75rem;
    cursor: pointer;
  }
}
</style>
